/**************************************************
 * Nombre:       Tarjetas_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useBotonCantidadTarjeta} from "../Hooks/useBotonCantidadTarjeta";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import marco from "../../Recursos/fondo_empanandas.svg";


const Tarjetas_Producto = ({item}) => {
    const {Boton, cantidad} = useBotonCantidadTarjeta({cantidad: item.cantidad, producto: item})


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2}}
            spacing={2}
        >

            <Grid container size={4}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        maskImage: `url(${marco})`,
                        maskRepeat: 'no-repeat',
                        maskSize: '100%',
                        //   maskBorder: 'alpha',
                        //  maskBorderWidth: 10,

                    }}>


                    <img src={item.img} width={'100%'} height={'auto'}/>

                </Grid>
            </Grid>

            <Grid container size={{xs: 8, sm: 8, md: 8}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                >



                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography
                            sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 16}}>{`${item.nombre}`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: 12,
                                textOverflow: "ellipsis",

                            }}>{`Valor und: ${formatoMoneda(item.valor)}`}</Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-end'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 4}}>
                                <Boton/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 8}}>
                                <Grid
                                    container
                                    justifyContent={'flex-end'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>


                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                                        <Typography sx={{fontWeight: 600, fontSize: 12, color: '#00000080'}}>
                                            Valor total
                                        </Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                                        <Typography sx={{
                                            fontWeight: 600,
                                            fontSize: 14,
                                        }}>{formatoMoneda(cantidad * item.valor)}</Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjetas_Producto    